import React from 'react';

import { PropertyRow } from 'components/layouts/rows';
import type { StringAttribute } from 'domain/experiment/attribute';

type StringRendererProps = {
  attribute?: StringAttribute;
  labelWidth?: string;
  label?: string;
  'data-name'?: string;
  copyable?: boolean;
  rowVariant?: 'compact' | 'default';
};

export const StringRenderer: React.FC<StringRendererProps> = ({
  attribute,
  labelWidth = '100px',
  label,
  'data-name': dataName,
  copyable = false,
  rowVariant = 'default',
}) => {
  if (!attribute) {
    return null;
  }

  const string = attribute.value;

  return (
    <PropertyRow
      value={string}
      labelWidth={labelWidth}
      label={label}
      data-name={dataName}
      copyable={copyable}
      variant={rowVariant}
    />
  );
};
